import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/blockchain`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getProof({commit}, payload: { jobId: string, hash: string }) {
    return axiosInstance.get(`${baseUrl}/jobs/${payload.jobId}/verify`, {})
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
